import { createEvent, sample, split } from "effector";
import { setPlayerTrackQueue, setPlayerCurrentTrackIndex, setPlayerCurrentTrackSourceIndex, $playerCurrentTrackSource, } from "frontend/src/domain/player-track-queue";
import { playCurrentTrackInQueueAttempted } from "frontend/src/features/play-track-from-queue";
import { createLoadTracksForCurrentTrackSourceModel } from "frontend/src/features/load-player-tracks-source";
import { notify } from "../notifications";
var _a = createLoadTracksForCurrentTrackSourceModel(), loadPlayerCurrentTracksSourceAttempted = _a.loadPlayerCurrentTracksSourceAttempted, tracksLoadedAndSet = _a.tracksLoadedAndSet;
export var playPlaylistAttempted = createEvent();
var playlistHasNoTracks = createEvent();
sample({
    clock: playPlaylistAttempted,
    fn: function (_a) {
        var tracks = _a.tracks, id = _a.id, title = _a.title;
        return ({
            type: "playlist",
            tracks: tracks,
            attributes: { id: id, title: title },
        });
    },
    target: setPlayerTrackQueue,
});
sample({
    clock: playPlaylistAttempted,
    fn: function (_a) {
        var startAtTrackIndex = _a.startAtTrackIndex;
        return startAtTrackIndex;
    },
    target: setPlayerCurrentTrackIndex,
});
sample({
    clock: playPlaylistAttempted,
    fn: function () { return 0; },
    target: setPlayerCurrentTrackSourceIndex,
});
playPlaylistAttempted.watch(function (_a) {
    var tracks = _a.tracks;
    if (tracks) {
        playCurrentTrackInQueueAttempted();
    }
    else {
        loadPlayerCurrentTracksSourceAttempted();
    }
});
split({
    source: sample({
        clock: tracksLoadedAndSet,
        source: $playerCurrentTrackSource,
        fn: function (trackSource) { return trackSource; },
    }),
    match: {
        loadedTimetableHasTracks: function (trackSource) {
            return trackSource !== null && trackSource.tracks.length > 0;
        },
    },
    cases: {
        loadedTimetableHasTracks: playCurrentTrackInQueueAttempted,
        __: playlistHasNoTracks,
    },
});
sample({
    clock: playlistHasNoTracks,
    source: playPlaylistAttempted,
    fn: function (_a) {
        var title = _a.title;
        return title;
    },
    target: notify.prepend(function (title) { return ({
        variant: "error",
        message: "\u0412 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0435 \"" + title + "\" \u043D\u0435\u0442 \u0442\u0440\u0435\u043A\u043E\u0432.",
    }); }),
});
